const routers = [

    {
        path: '/strategy/Restrict',
        name: 'Restrict',
        component: resolve => require(['../views/strategy/Restrict'], resolve)
    },
    {
        path: '/strategy/Wifi',
        name: 'Wifi',
        component: resolve => require(['../views/strategy/Wifi'], resolve)
    },
    {
        path: '/strategy/appWhiteList',
        name: 'AppWhite',
        component: resolve => require(['../views/strategy/AppWhite'], resolve)
    },
    {
        path: '/strategy/appBlackList',
        name: 'AppBlack',
        component: resolve => require(['../views/strategy/AppBlack'], resolve)
    },
    {
        path: '/strategy/fastConfig',
        name: 'SpeedConfig',
        component: resolve => require(['../views/strategy/SpeedConfig'], resolve)
    },
    {
        path: '/strategy/appFreezer',
        name: 'AppFreezer',
        component: resolve => require(['../views/strategy/AppFreezer'], resolve)
    },
    {
        path: '/strategy/apnConfig',
        name: 'ApnConfig',
        component: resolve => require(['../views/strategy/ApnConfig'], resolve)
    },
    {
        path: '/strategy/allStrategyConfig',
        name: 'AllStrategyConfig',
        component: resolve => require(['../views/strategy/AllStrategyConfig'], resolve)
    },
    {
        path: '/strategy/deviceFence',
        name: 'Fence',
        component: resolve => require(['../views/strategy/Fence'], resolve)
    }
    
    
]
export default routers



// WEBPACK FOOTER //
// ./src/routers/strategy.js